// ==========================================
// 2. SERVICE API ANGULAR (src/app/core/services/api.service.ts)
// ==========================================

import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Antenna, Commission, EventHelloAsso, NewsItem, Resource } from '../models/agbe.models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private http = inject(HttpClient);
  // URL de votre API PHP (ex: Slim Framework, Laravel ou PHP natif)
  private readonly apiUrl = environment.apiUrl;

  // Signals globaux pour partage d'état
  public antennas = signal<Antenna[]>([]);
  public news = signal<NewsItem[]>([]);

  // Endpoints PHP
  getAntennas(): Observable<Antenna[]> {
    return this.http.get<Antenna[]>(`${this.apiUrl}/antennes`);
  }

  getNews(): Observable<NewsItem[]> {
    return this.http.get<NewsItem[]>(`${this.apiUrl}/news`);
  }

  getResources(category?: string): Observable<Resource[]> {
    return this.http.get<Resource[]>(`${this.apiUrl}/resources`, {
      params: category ? { category } : {},
    });
  }

  getEvents(): Observable<EventHelloAsso[]> {
    return this.http.get<EventHelloAsso[]>(`${this.apiUrl}/events`);
  }

  getCommissions(): Observable<Commission[]> {
    return this.http.get<Commission[]>(`${this.apiUrl}/commissions`);
  }

  getPartners(): Observable<any[]> { return this.http.get<any[]>(`${this.apiUrl}/partners`); }
  getBibleStudies(): Observable<any[]> { return this.http.get<any[]>(`${this.apiUrl}/bible-studies`); }

  submitContact(data: any): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/contact`, { ...data, type: 'contact' });
  }

  submitMembership(data: any): Observable<{ success: boolean; message: string }> {
    const message = [
      `Téléphone : ${data.telephone || 'Non renseigné'}`,
      `Ville : ${data.ville || 'Non renseignée'}`,
      `Église locale : ${data.egliseLocale || 'Non renseignée'}`,
      '',
      data.motivation || 'Aucun message complémentaire.',
    ].join('\n');

    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/contact`, {
      ...data,
      type: 'membership',
      name: `${data.prenom || ''} ${data.nom || ''}`.trim(),
      phone: data.telephone,
      subject: "Demande d'adhésion",
      message,
      website: '',
    });
  }

  submitRegistration(data: any): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(
      `${this.apiUrl}/inscription-antenne.php`,
      data,
    );
  }
}
